/* unplugin-vue-components disabled */import { render } from "./GoodList.vue?vue&type=template&id=4b5f2524&scoped=true&ts=true"
import script from "./GoodList.vue?vue&type=script&lang=ts"
export * from "./GoodList.vue?vue&type=script&lang=ts"

import "./GoodList.vue?vue&type=style&index=0&id=4b5f2524&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5f2524"]])

export default __exports__